
























import Vue from "vue";
import Component from "vue-class-component";
import axios from "axios";
import UserService from '../services/UserService'
import AuthInfo from '../kne/authToken'

@Component({})
export default class MyComponent extends Vue {
  // Initial data can be declared as instance properties
  public name = "";
  public password = "";
  userService: UserService;

  constructor(){
    super();
    this.userService = new UserService();
  }

  // Component methods can be declared as instance methods
  Login() {
    this.userService.login(this.name, this.password).then((data: AuthInfo) => {
      this.$store.commit("user/setAuthToken", data)
      this.$store.dispatch("products/loadAllProducts");
      this.$router.push("/product/1")
    })
  }

  mounted(){
    const t: any = this.$store.state.user.accesstoken;
  }
}
